import React, { useState } from 'react';
import { Checkbox, TextField, FormControlLabel } from '@material-ui/core';

import DialogDefault from '../common/DialogDefault';

const ModalCreateLocation = ({
	open,
	toggle,
	addLocation,
	toggleLastgangHochladen,
	toggleAddInformationModal,
}) => {
	const NIEDERLASSUNG = 'Neue Niederlassung';
	const [inputLocationName, setInputLocationName] = useState(NIEDERLASSUNG);
	const [checkBoxLastGang, setCheckBoxLastgang] = useState(false);
	const [checkBoxAddInformation, setCheckBoxAddInformation] = useState(false);

	const submitData = () => {
		toggle();
		addLocation(inputLocationName);
		resetState();
		if (checkBoxLastGang) {
			toggleLastgangHochladen();
			setCheckBoxLastgang(false);
		}
		if (checkBoxAddInformation) {
			toggleAddInformationModal();
			setCheckBoxAddInformation(false);
		}
	};

	const resetState = () => {
		setInputLocationName(NIEDERLASSUNG);
		setCheckBoxLastgang(false);
	};

	const onChangeLastgang = () => {
		setCheckBoxLastgang(!checkBoxLastGang);
	};

	const onChangeNiederlassung = () => {
		setCheckBoxAddInformation(!checkBoxAddInformation);
	};

	return (
		<DialogDefault
			headline="Neue Niederlassung erstellen"
			openModal={open}
			closeModal={toggle}
			confirmButton={submitData}
			confirmButtonText="Erstellen"
		>
			<form className="form" autoComplete="off" onSubmit={submitData}>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					label="Niederlassung"
					inputProps={{
						maxLength: 20,
					}}
					onInput={(e) => setInputLocationName(e.target.value)}
				/>
				<div className="form__item">
					<FormControlLabel
						control={
							<Checkbox
								onChange={onChangeNiederlassung}
								name="checkLocation"
							/>
						}
						label="Informationen zur Niederlassung eingeben"
					/>
				</div>
				<div className="form__item">
					<FormControlLabel
						control={
							<Checkbox
								onChange={onChangeLastgang}
								name="checkLoadProfile"
							/>
						}
						label="Lastgang hochladen"
					/>
				</div>
			</form>
		</DialogDefault>
	);
};

export default ModalCreateLocation;
